__turbopack_context__.v({
  "buttons": "SwiperSlider-module-scss-module__AL1jpq__buttons",
  "buttons__nextButton": "SwiperSlider-module-scss-module__AL1jpq__buttons__nextButton",
  "buttons__prevButton": "SwiperSlider-module-scss-module__AL1jpq__buttons__prevButton",
  "image": "SwiperSlider-module-scss-module__AL1jpq__image",
  "image__desktop": "SwiperSlider-module-scss-module__AL1jpq__image__desktop",
  "image__mobile": "SwiperSlider-module-scss-module__AL1jpq__image__mobile",
  "video": "SwiperSlider-module-scss-module__AL1jpq__video",
});
